import { useId, useState } from 'react';
import { type FooterLevelOneGroup } from '@cx-web/domain-types';
import { trackEvent } from '@cx-web/utils/dataLayer';
import classnames from 'classnames';

import FooterNavGroupTitle from './components/FooterNavGroupTitle/index';
import styles from './FooterNavGroup.module.css';

const Sublink = ({ link, name }: { link: string; name: string }) => {
  return (
    <li className={styles.subLinkItem}>
      <a
        className={styles.subLink}
        href={link}
        onClick={() => trackEvent('footer_level_one_nav', { selection: name })}
        title={name}
      >
        {name}
      </a>
    </li>
  );
};

type FooterNavGroupProps = FooterLevelOneGroup & {
  isUkFooterStyle?: boolean;
};

export const FooterNavGroup = ({ isUkFooterStyle, name, subLinks }: FooterNavGroupProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const subLinksId = useId();

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  return (
    <li
      className={classnames(styles.footerNavGroupWrapper, {
        [styles.footerNavGroupWrapperUk]: isUkFooterStyle,
      })}
      data-testid="footer-level-one-group"
    >
      <FooterNavGroupTitle
        isOpen={isOpen}
        isUkFooterStyle={isUkFooterStyle}
        subLinksId={isUkFooterStyle ? subLinksId : undefined}
        title={name}
        toggle={toggle}
      />
      <ul
        className={classnames(styles.footerNavSubLinks, {
          [styles.open]: isOpen,
          [styles.footerNavSubLinksUk]: isUkFooterStyle,
        })}
        id={isUkFooterStyle ? subLinksId : undefined}
      >
        {subLinks.map(({ link, name }) => (
          <Sublink key={name} link={link} name={name} />
        ))}
      </ul>
    </li>
  );
};
